import Modal from 'LuxKit/Modal/Modal'
import React, { useCallback, useContext } from 'react'
import ChatsHistoryList from './ChatsHistoryList'
import NewChatModal, { NewChatModalResult } from '../Chat/NewChatModal'
import ModalContext from 'contexts/ModalContext'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { createNewChat } from 'actions/supportAssistant/supportAssistantActions'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import AccountAccessModal from 'components/Account/AccountAccess/AccountAccessModal'

export interface ChatHistoryModalResult {
  chatId: string | undefined
}

function ChatsHistoryModal() {
  const dispatch = useAppDispatch()
  const customerId = useAppSelector(state => state.auth.account.memberId)
  const currentChatId = useAppSelector(state => state.supportAssistant.currentChatId)

  const showModal = useContext(ModalContext)

  const modalElement = useModalElementContext<ChatHistoryModalResult>()

  const handleNewChatClick = useCallback(async() => {
    if (!customerId && currentChatId) {
      const result = await showModal<NewChatModalResult>(<NewChatModal />)
      if (result.triggerLogin) {
        showModal(<AccountAccessModal />)
      }
      modalElement.resolve({ chatId: undefined })
    } else {
      dispatch(createNewChat())
      modalElement.resolve({ chatId: undefined })
    }
  }, [currentChatId, customerId, dispatch, modalElement, showModal])

  const handleSelectChatClick = useCallback((chatId: string) => {
    modalElement.resolve({ chatId })
  }, [modalElement])

  return (
    <Modal
      title="Chat History"
      mode="menu"
      height="full"
      primaryActionText="New Chat"
      onPrimaryActionClick={handleNewChatClick}
    >
      <ChatsHistoryList onChatSelect={handleSelectChatClick} />
    </Modal>
  )
}

export default ChatsHistoryModal
